import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Card, CardBody, DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from "reactstrap";
import AuthCornerImage from "../../assets/img/illustrations/authentication-corner.png";
import { breakpoints, getPageName } from "../../helpers/utils";
import { topNavbarBreakpoint } from "../../config";

const NavbarDropdown = ({ title, items, right, children, handleSetNavbarCollapsed }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const isLanding = getPageName("");
  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggleDropdown}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(true);
        }
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      <DropdownToggle nav caret>
        {title}
      </DropdownToggle>
      <DropdownMenu right={right} className="dropdown-menu-card mt-0">
        {items.length > 0 && (
          <Card
            className={classNames("shadow-none max-h-dropdown", {
              "navbar-card-pages": title === "Pages",
              "navbar-card-auth": title === "Authentication",
            })}
          >
            {title === "Authentication" && (
              <img src={AuthCornerImage} alt="" className="position-absolute b-0 r-0" width={130} />
            )}
            <CardBody className={classNames("scrollbar px-0 py-2", { "p-0": title === "Home" })}>
              <div className="nav flex-column">
                {items.map(({ to, name }, index) =>
                  isLanding ? (
                    <DropdownItem tag="a" href={to} key={index} target="_blank" onClick={handleSetNavbarCollapsed}>
                      {name}
                    </DropdownItem>
                  ) : (
                    <DropdownItem tag={Link} to={to} key={index} onClick={handleSetNavbarCollapsed}>
                      {name}
                    </DropdownItem>
                  )
                )}
              </div>
            </CardBody>
          </Card>
        )}
        {children}
      </DropdownMenu>
    </Dropdown>
  );
};

NavbarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  handleSetNavbarCollapsed: PropTypes.func,
  children: PropTypes.node,
  items: PropTypes.array,
  right: PropTypes.bool,
};

NavbarDropdown.defaultProps = {
  items: [],
  right: false,
  children: null,
};

export default NavbarDropdown;
